import type { FeatureCollection, Feature, Polygon } from 'geojson'
import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapSingle } from './normalize'

export default async function getSoils({
  geoJSON,
  signal,
}: {
  geoJSON: Feature<Polygon>
  signal?: AbortSignal
}): Promise<FeatureCollection> {
  const response = await apiClient.post(`${endpoints.soils}/intersection`, { geoJSON }, { signal })
  return unwrapSingle<FeatureCollection>(response)
}
